import React from "react";
import { Link } from "react-router-dom";
import { HiArrowRight, HiArrowUpRight } from "react-icons/hi2";
import { usePrefetchPublicRoute } from "../../../../hooks/usePrefetchPublicRoute";
import "./RelatedNews.css";

const RelatedNews = ({ posts }) => {
  const prefetchRoute = usePrefetchPublicRoute();
  if (!posts?.length) return null;

  return (
    <section className="related-news">
      <div className="related-news__container">
        <span className="related-news__badge">Newsroom</span>

        <div className="related-news__header">
          <h2 className="related-news__title">From the blog</h2>
          <Link to="/news" className="related-news__view-all">
            <span>View all news</span>
            <HiArrowRight />
          </Link>
        </div>

        <div className="related-news__grid">
          {posts.map((post) => (
            <Link
              key={post.id}
              to={`/news/${post.slug}`}
              className="related-news__card"
              onMouseEnter={() => prefetchRoute(`/news/${post.slug}`)}
              onFocus={() => prefetchRoute(`/news/${post.slug}`)}
            >
              <img
                src={post.image}
                alt=""
                className="related-news__card-image"
              />
              <time className="related-news__card-date">{post.date}</time>
              <div className="related-news__card-title-row">
                <h3 className="related-news__card-title">{post.title}</h3>
                <HiArrowUpRight
                  className="related-news__card-arrow"
                  aria-hidden="true"
                />
              </div>
              <p className="related-news__card-description">
                {post.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedNews;
